import cn from 'classnames';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import BackButton from '../../../../components/BackButton/BackButton';
import {DualLayout} from '../../../../components/DataDisplay';
import ReconnectGuideVideo from '../../../../components/Reconnect/ReconnectGuideVideo';
import appConfig from '../../../../config/appConfig';
import analyticsService from '../../../../services/analyticsService';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import {selectIotDeviceType} from '../../../../state/selectors/iotDevice';

const ReconnectGuideComponent = (props) => {
    const {guideData, hideModalGuide} = props;
    const {header, reconnectStepList} = guideData;
    const localizedStrings = getLocalizedStrings();
    const description = reconnectStepList?.map((step) => localizedStrings[step]);
    const deviceType = useSelector(selectIotDeviceType);
    const isRestrictedMarket = appConfig.getIsRestrictedMarket();

    useEffect(() => {
        analyticsService.pushBleReconnectionGuideEvent(deviceType);
    }, []);

    return (
        <>
            <BackButton onClick={hideModalGuide} className='absolute z-20' />
            <DualLayout
                className='lg:py-36'
                classNameRight='overflow-hidden flex items-center'
                articleProps={{
                    titleKey: header,
                    titleClassName: cn('mt-8 mb-3 lg:mt-0 lg:mb-4', {'md-max:mt-8': isRestrictedMarket}),
                    descriptionText: description?.join(' '),
                }}
            >
                <ReconnectGuideVideo className='h-full w-full' />
            </DualLayout>
        </>
    );
};

export default ReconnectGuideComponent;
